import { DOCUMENT, Inject, Injectable } from "@angular/core";
import { environment } from "src/environments";

// Defining a variable for the global function name allows us to ensure it's the
// same in the script path and when defining it. That requires using a TS mapped
// type (`WindowCallback`) and then using that to extend the `Window` interface.
const mapsCallbackName = "managedReceivingGoogleMapsApiLoaded";
type WindowCallback = { [P in typeof mapsCallbackName]?: () => void };
declare global {
  // No extra properties to add except in `WindowCallback` but we still need to
  // extend the existing `Window`, so this empty interface is necessary.
  interface Window extends WindowCallback {}
}

const key = environment.googleMapsApiKey;
const placesScriptPath = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${key}&callback=${mapsCallbackName}`;

@Injectable({ providedIn: "root" })
export class GoogleMapsService {
  public constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  private maps?: Promise<typeof google.maps>;

  public async load(): Promise<typeof google.maps> {
    if (!this.maps) {
      const script = this.document.createElement("script");
      script.type = "text/javascript";
      script.src = placesScriptPath;

      this.maps = new Promise((resolve) => {
        window[mapsCallbackName] = () => resolve(google.maps);
        this.document.head.appendChild(script);
      });
    }

    return this.maps;
  }
}
